/**
 * @generated SignedSource<<e5dbaa6787fe35c152f3a7c84e4055d6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type emailStep_LeadConvertMutation$variables = {
  email: string;
  nextStepKey?: string | null | undefined;
  token?: string | null | undefined;
};
export type emailStep_LeadConvertMutation$data = {
  readonly leadConvert: {
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly status: string;
    readonly token: string | null | undefined;
  } | null | undefined;
};
export type emailStep_LeadConvertMutation = {
  response: emailStep_LeadConvertMutation$data;
  variables: emailStep_LeadConvertMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "email"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "nextStepKey"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "token"
},
v3 = [
  {
    "kind": "Variable",
    "name": "email",
    "variableName": "email"
  },
  {
    "kind": "Variable",
    "name": "nextStepKey",
    "variableName": "nextStepKey"
  },
  {
    "kind": "Variable",
    "name": "token",
    "variableName": "token"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "token",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "emailStep_LeadConvertMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "LeadConvertMutationPayload",
        "kind": "LinkedField",
        "name": "leadConvert",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v6/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "emailStep_LeadConvertMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "LeadConvertMutationPayload",
        "kind": "LinkedField",
        "name": "leadConvert",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "4355b3c483fbb9f3f230a5f17a05865a",
    "id": null,
    "metadata": {},
    "name": "emailStep_LeadConvertMutation",
    "operationKind": "mutation",
    "text": "mutation emailStep_LeadConvertMutation(\n  $email: String!\n  $token: String\n  $nextStepKey: String\n) {\n  leadConvert(email: $email, token: $token, nextStepKey: $nextStepKey) {\n    status\n    token\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "1730f87fd6043758605cfd73c527235c";

export default node;
